import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-black-list-modal',
    templateUrl: './black-list-modal.component.html',
    styleUrls: ['./black-list-modal.component.scss']
})
export class BlackListModalComponent implements OnInit {

    public param: object;

    constructor(
        public dialogRef: MatDialogRef<BlackListModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: Object
    ) { }

    ngOnInit() {
        this.param = {
            browserName: this.data['userBrowser'].name,
            browserVersion: this.data['userBrowser'].version
        };
    }

}